import styled from 'styled-components';

export const SubSection = styled.div`
  display: flex;
  margin-top: 1rem;
  gap: 2rem;
`;
